import { parseCardAwsJsonField } from './parse-card-awsjson.util';

/**
 * Card `visualization` may be a plain object or an AppSync `AWSJSON` string at runtime.
 */
export function parseChartVisualizationInput(value: unknown): unknown {
	return parseCardAwsJsonField(value);
}

/** True when there are no persisted overrides (after normalizing AWSJSON strings). */
export function isChartVisualizationPayloadEmpty(value: unknown): boolean {
	const parsed = parseChartVisualizationInput(value);
	if (parsed == null) {
		return true;
	}
	if (typeof parsed !== 'object') {
		return true;
	}
	if (Array.isArray(parsed)) {
		return parsed.length === 0;
	}
	return Object.keys(parsed).length === 0;
}
